/* AB&T custom track builders (sections/abt-builder.liquid). One engine, two modes:
   acoustic: fixed prices from the "Custom builder prices" metaobject (Content > Metaobjects)
   platinum: price ranges from the section's instrument blocks
   Sending a request posts to the portal, which creates a draft order for Sheldon to check. */
(() => {
  // ---------- Instrument line art (120 × 120) ----------
  const keyRow = (x, y, w, h, n, bh) => {
    const kw = w / n; let s = '';
    for (let i = 1; i < n; i++) s += `<path class="thin" d="M${(x + i * kw).toFixed(1)} ${y}v${h}"/>`;
    for (let i = 0; i < n - 1; i++) if ([0, 1, 3, 4, 5].includes(i % 7))
      s += `<rect class="f" x="${(x + (i + 1) * kw - kw * .3).toFixed(1)}" y="${y}" width="${(kw * .6).toFixed(1)}" height="${bh}" rx=".8"/>`;
    return s;
  };
  // Frets from the real scale length (distance from nut = scale × (1 − 2^(−n/12))), tapering with the neck
  const fretYs = (nut, scale, upTo) => Array.from({ length: upTo }, (_, k) => +(nut + scale * (1 - Math.pow(2, -(k + 1) / 12))).toFixed(1));
  const fretsTaper = (nutY, nutHalf, endY, endHalf, ys) => ys.map(y => { const h = nutHalf + (endHalf - nutHalf) * (y - nutY) / (endY - nutY); return `M${(60 - h).toFixed(2)} ${y}H${(60 + h).toFixed(2)}`; }).join('');
  const ART = {
    drums: `<ellipse cx="15" cy="37" rx="11" ry="2.2"/><ellipse cx="15" cy="41" rx="11" ry="2.2"/><path d="M15 43v63M15 106l-6 5M15 106l6 5"/>
      <ellipse cx="103" cy="30" rx="14" ry="2.8" transform="rotate(-12 103 30)"/><path d="M103 33v38"/>
      <ellipse cx="46" cy="50" rx="11" ry="4.5"/><path d="M35 50v9a11 4.5 0 0 0 22 0v-9"/>
      <ellipse cx="74" cy="50" rx="11" ry="4.5"/><path d="M63 50v9a11 4.5 0 0 0 22 0v-9"/>
      <circle cx="60" cy="84" r="23"/><circle cx="60" cy="84" r="8"/><path d="M45 102l-5 8M75 102l5 8"/>
      <ellipse cx="28" cy="74" rx="12" ry="4"/><path d="M16 74v8a12 4 0 0 0 24 0v-8M28 87v19M28 106l-6 5M28 106l6 5"/>
      <ellipse cx="99" cy="76" rx="12" ry="4.5"/><path d="M87 76v18a12 4.5 0 0 0 24 0V76M89 98l-2 12M109 98l2 12"/>`,
    bass: `<g transform="rotate(30 60 58)">
    <path d="M63.2 79.6C65.6 78.6 68.2 75.2 70 73.2C71.8 71.2 75.6 71.8 75.9 75.4C76.2 79 73.6 82 74 86.5C74.4 91 77.2 93.5 77.2 99.5C77.2 107.8 69.6 114 60 114C50.4 114 42.8 107.8 42.8 99.5C42.8 93.2 46 89.8 46 85.5C46 79.5 43.4 76 43.9 72C44.4 67.8 48.4 67.2 50.4 69.8C52.4 72.4 54.4 77.6 56.8 79.6Z"/>
    <path class="thin" d="M56.8 82C51.5 83.5 48.6 87 49 92.5C49.4 97.5 54 101 60 102.5C65 103.6 70 102.8 72.4 99.5"/>
    <rect x="52" y="89.6" width="8.2" height="3.2" rx="1.6"/><rect x="59.8" y="93.2" width="8.2" height="3.2" rx="1.6"/>
    <rect x="53" y="105.6" width="14" height="3.8" rx="1"/>
    <circle cx="71.6" cy="103.4" r="2.1"/><circle cx="68.6" cy="108.8" r="2.1"/>
    <path d="M57.8 21.1L56.8 81M62.2 21.1L63.2 81M56.8 81H63.2"/>
    <path class="thin" d="${fretsTaper(21.1, 2.2, 81, 3.2, fretYs(21.1, 86.5, 20))}"/>
    <path d="M57.8 21.1L57.2 4.5C57.2 2 60 1.4 62.4 2.6C64.2 3.5 64.6 5.6 66.6 6.6C68.6 7.6 69.4 9.6 68 11.4C66.8 12.9 64.5 13.2 63.4 14.6C62.6 15.7 62.3 18 62.2 21.1"/>
    <path d="M57.3 5h-2.8M57.4 9h-2.8M57.5 13h-2.8M57.6 17h-2.8"/>
    <ellipse cx="53" cy="5" rx="1.9" ry="1.3"/><ellipse cx="53.1" cy="9" rx="1.9" ry="1.3"/><ellipse cx="53.2" cy="13" rx="1.9" ry="1.3"/><ellipse cx="53.3" cy="17" rx="1.9" ry="1.3"/>
    <path class="thin" d="M58.6 21.1L58.3 107.5M59.6 21.1L59.5 107.5M60.4 21.1L60.5 107.5M61.4 21.1L61.7 107.5"/></g>`,
    electric_guitar: `<g transform="rotate(-36 60 60)">
    <path d="M63.1 72C65.5 71 68 67.5 70 64.8C71.8 62.5 75.5 62.8 76 66.5C76.4 70 74 74 74.5 79C75 84 78 90 78 100C78 109.5 70 116 60 116C50 116 42 109.5 42 100C42 91 45.5 85.5 45.5 79.5C45.5 73 43 68 43.5 63C44 59 48 58 50 60.5C52.5 63.5 54.5 69 56.9 72Z"/>
    <path class="thin" d="M56.9 74C51 75.5 47.5 79 47.5 85C47.5 92 53 97 60 99.5C66 101.5 71.5 101 74 97.5"/>
    <rect x="54.6" y="79.2" width="10.8" height="2.2" rx="1.1"/><rect x="54.6" y="85.6" width="10.8" height="2.2" rx="1.1"/>
    <rect x="54.6" y="92.2" width="10.8" height="2.2" rx="1.1" transform="rotate(-8 60 93.3)"/>
    <rect x="53.6" y="97" width="12.8" height="4.6" rx="1"/>
    <circle cx="70.6" cy="97.4" r="1.9"/><circle cx="69.1" cy="103" r="1.9"/><circle cx="67.4" cy="108.4" r="1.9"/>
    <path d="M57.7 27L56.9 78M62.3 27L63.1 78M56.9 78H63.1"/>
    <path class="thin" d="${fretsTaper(27, 2.3, 78, 3.1, fretYs(27, 71.4, 21))}"/>
    <path d="M57.7 27L57.2 9C57.2 6 59.5 5 62 6.2C64.5 7.4 66 9 68.5 9.8C71.5 10.8 72.5 13.5 71 15.8C69.6 18 66.5 18.5 64.5 20C63 21.2 62.5 23.5 62.3 27"/>
    <path d="M57.3 9h-2.2M57.3 11.6h-2.2M57.4 14.2h-2.2M57.4 16.8h-2.2M57.5 19.4h-2.2M57.5 22h-2.2"/>
    <circle class="f" cx="54.3" cy="9" r="1"/><circle class="f" cx="54.3" cy="11.6" r="1"/><circle class="f" cx="54.4" cy="14.2" r="1"/><circle class="f" cx="54.4" cy="16.8" r="1"/><circle class="f" cx="54.5" cy="19.4" r="1"/><circle class="f" cx="54.5" cy="22" r="1"/>
    <path class="thin" d="M58.8 27L58.6 98.4M60 27V98.4M61.2 27L61.4 98.4"/></g>`,
    keys: `<rect x="8" y="44" width="104" height="28" rx="4"/><path d="M8 53h104"/>
      <circle cx="15" cy="48.5" r="1.6"/><circle cx="21" cy="48.5" r="1.6"/><rect x="84" y="46.5" width="20" height="4" rx="1"/>
      ${keyRow(8, 53, 104, 19, 15, 11)}<path d="M30 72L90 110M90 72L30 110"/>`,
    guitar: `<g transform="rotate(-32 60 58)">
    <path d="M60 59C67 59 71.2 59.2 73.6 61.1C75.6 62.8 75.6 66 75.6 71.2C75.6 76.5 74.3 79.3 74.6 82.1C74.9 85.5 81.2 90 81.2 98.4C81.2 107.4 72.8 113.4 60 113.4C47.2 113.4 38.8 107.4 38.8 98.4C38.8 90 45.1 85.5 45.4 82.1C45.7 79.3 44.4 76.5 44.4 71.2C44.4 66 44.4 62.8 46.4 61.1C48.8 59.2 53 59 60 59Z"/>
    <circle cx="60" cy="71.6" r="5.4"/><circle class="thin" cx="60" cy="71.6" r="7.2"/>
    <path class="thin" d="M66.2 75.5C71.5 76 74 80.5 72.2 85C70.8 88.2 66.8 88.4 64.8 85.6"/>
    <rect x="51.9" y="88.2" width="16.2" height="3.6" rx="1.5"/>
    <path d="M57.7 20.7L57.05 65.5M62.3 20.7L62.95 65.5M57.05 65.5H62.95"/>
    <path class="thin" d="${fretsTaper(20.7, 2.3, 65.5, 2.95, fretYs(20.7, 69.1, 17))}"/>
    <path d="M57.7 20.7L55.3 15.5V5.2Q55.3 3 57.5 3H62.5Q64.7 3 64.7 5.2V15.5L62.3 20.7"/>
    <path d="M55.3 6.6h-2.4M55.3 10.6h-2.4M55.3 14.6h-2.4M64.7 6.6h2.4M64.7 10.6h2.4M64.7 14.6h2.4"/>
    <ellipse cx="51.6" cy="6.6" rx="1.4" ry="1.1"/><ellipse cx="51.6" cy="10.6" rx="1.4" ry="1.1"/><ellipse cx="51.6" cy="14.6" rx="1.4" ry="1.1"/>
    <ellipse cx="68.4" cy="6.6" rx="1.4" ry="1.1"/><ellipse cx="68.4" cy="10.6" rx="1.4" ry="1.1"/><ellipse cx="68.4" cy="14.6" rx="1.4" ry="1.1"/>
    <path class="thin" d="M58.6 20.7L58.3 89.8M60 20.7V89.8M61.4 20.7L61.7 89.8"/></g>`,
    strings: `<path d="M60 40C46 40 40 48 42 58C43 64 48 66 48 70C48 74 40 76 38 88C36 102 46 110 60 110C74 110 84 102 82 88C80 76 72 74 72 70C72 66 77 64 78 58C80 48 74 40 60 40Z"/>
      <path d="M57.5 40V12M62.5 40V12"/><path d="M60 12c-3 0-5-2-5-5s2-5 5-5 4 2 4 4-1.5 3-3 3"/><path d="M60 110v8"/>
      <path d="M52 72c-3 5 3 10 0 17M68 72c3 5-3 10 0 17M52 92h16"/><path class="thin" d="M58.5 12v80M61.5 12v80"/>
      <path d="M14 101L106 40"/><path class="thin" d="M17 105L108 45"/><path d="M106 40l2 5"/>`,
    double_bass: `<g transform="rotate(-8 60 60)">
    <path d="M60 43.6C64 43.6 66.5 45 69.5 48.5C73.5 52.6 76.4 54.5 76.4 59C76.4 64 71.2 67.5 71.2 75.6C71.2 82 81.2 85 81.2 95C81.2 106 72 112.9 60 112.9C48 112.9 38.8 106 38.8 95C38.8 85 48.8 82 48.8 75.6C48.8 67.5 43.6 64 43.6 59C43.6 54.5 46.5 52.6 50.5 48.5C53.5 45 56 43.6 60 43.6Z"/>
    <path d="M57.8 14L56.8 80M62.2 14L63.2 80M56.8 80H63.2"/>
    <path d="M57.8 14V6.8M62.2 14V6.8"/><circle cx="60" cy="4.2" r="3"/><path class="thin" d="M58.8 4.2a1.2 1.2 0 1 0 2.4 0"/>
    <path d="M57.8 8.2h-3.6M57.8 11.8h-3.6M62.2 8.2h3.6M62.2 11.8h3.6"/>
    <circle cx="53" cy="8.2" r="1.2"/><circle cx="53" cy="11.8" r="1.2"/><circle cx="67" cy="8.2" r="1.2"/><circle cx="67" cy="11.8" r="1.2"/>
    <path d="M51.6 73c-3 4 3 10 0 16M68.4 73c3 4-3 10 0 16"/><circle class="f" cx="51.6" cy="73" r=".9"/><circle class="f" cx="51.6" cy="89" r=".9"/><circle class="f" cx="68.4" cy="73" r=".9"/><circle class="f" cx="68.4" cy="89" r=".9"/>
    <path d="M53 93.5L54 90.6Q60 89.2 66 90.6L67 93.5"/>
    <path d="M56.6 98L57.8 108.6H62.2L63.4 98Z"/><path d="M60 112.9v6"/>
    <path class="thin" d="M58.5 14L58.2 98M59.5 14V98M60.5 14V98M61.5 14L61.8 98"/></g>`,
    percussion: `<path d="M28 52L40 44H84L72 52Z"/><rect x="28" y="52" width="44" height="58" rx="2"/><path d="M72 52L84 44V102L72 110"/>
      <circle cx="50" cy="88" r="8"/><circle cx="98" cy="34" r="13"/><circle cx="98" cy="34" r="9.5" class="thin"/>
      <circle class="f" cx="98" cy="21" r="2.2"/><circle class="f" cx="111" cy="34" r="2.2"/><circle class="f" cx="98" cy="47" r="2.2"/><circle class="f" cx="85" cy="34" r="2.2"/>
      <path d="M12 104l10-22"/><ellipse cx="24" cy="78" rx="5" ry="8" transform="rotate(24 24 78)"/>`,
    banjo: `<g transform="rotate(-24 60 60)"><circle cx="60" cy="88" r="24"/><circle cx="60" cy="88" r="19"/>
      <path d="M56.5 64V14M63.5 64V14"/><path d="M56 14L55 2H65L64 14Z"/><path d="M55 5h-4M55 10h-4M65 5h4M65 10h4M56.5 40h-4"/>
      <path d="M53 98h14M60 112v-4"/><path class="thin" d="M58 14v94M59.3 14v94M60.7 14v94M62 14v94M57 40v68"/></g>`,
    brass: `<path d="M5 50v8M5 54h15H80"/><path d="M80 50C92 50 102 43 112 33V77C102 67 92 60 80 60Z"/>
      <rect x="42" y="44" width="7" height="27" rx="1.5"/><rect x="52" y="44" width="7" height="27" rx="1.5"/><rect x="62" y="44" width="7" height="27" rx="1.5"/>
      <circle cx="45.5" cy="38" r="2.6"/><circle cx="55.5" cy="38" r="2.6"/><circle cx="65.5" cy="38" r="2.6"/>
      <path d="M45.5 40.6v3.4M55.5 40.6v3.4M65.5 40.6v3.4"/><path d="M30 74H74C82 74 82 88 74 88H30C22 88 22 74 30 74"/>`,
    synths: `<rect x="10" y="42" width="100" height="50" rx="6"/><rect x="17" y="49" width="30" height="16" rx="2"/>
      <path d="M20 57q3-6 6 0t6 0t6 0t6 0" stroke-width="1.6"/>
      <circle cx="59" cy="54" r="4.2"/><circle cx="72" cy="54" r="4.2"/><circle cx="85" cy="54" r="4.2"/><circle cx="98" cy="54" r="4.2"/>
      <path d="M59 54v-3M72 54l2.2-2.2M85 54l-2.2-2.2M98 54v-3" stroke-width="1.6"/>
      <rect x="17" y="70" width="86" height="16" rx="2"/>${keyRow(17, 70, 86, 16, 12, 9)}<path d="M24 92v14M96 92v14M14 106h92"/>`,
    vocals: `<g transform="rotate(-28 52 64)"><rect x="42" y="16" width="20" height="30" rx="10"/><path class="thin" d="M42 26h20M42 33h20"/>
      <path d="M45 46h14l-3 52h-8Z"/><path d="M52 98v8"/></g><path d="M80 24c6 5 9 12 9 20M90 14c9 8 14 19 14 30M76 36c3 2 5 6 5 10"/>`,
    you: `<rect x="53" y="6" width="14" height="22" rx="7"/><path class="thin" d="M53 14h14M53 19h14"/>
      <path d="M60 28v6M55 34h10M60 34v70M60 104l-16 8M60 104l16 8M60 104v8"/>`,
  };
  const COLORS = { guitar: '#3fd49b', electric_guitar: '#3fd8ff', keys: '#b48cff', strings: '#ff6f91', double_bass: '#4f8dff', bass: '#4f8dff',
    percussion: '#ff9f45', drums: '#ff7a45', banjo: '#ffc23d', brass: '#ffc23d', synths: '#3fd8ff', vocals: '#e879f9' };
  const svg = art => `<svg class="bb-ico" viewBox="0 0 120 120" aria-hidden="true">${ART[art] || ART.keys}</svg>`;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const money = n => '£' + (Math.abs(n - Math.round(n)) < .005 ? Math.round(n).toLocaleString('en-GB') : n.toFixed(2));
  const rgba = (hex, a) => { const n = parseInt(hex.slice(1, 7), 16); return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${a})`; };

  document.querySelectorAll('[data-abt-builder]').forEach(init);

  function init(root) {
    const cfg = JSON.parse(root.querySelector('[data-config]').textContent);
    // Custom AI has no stage, instruments or licence choice: just its fixed price, extras and the form
    const acoustic = cfg.mode === 'acoustic', ai = cfg.mode === 'ai', band = cfg.mode === 'platinum';
    const P = Object.fromEntries(Object.entries(cfg.prices || {}).map(([k, v]) => [k, +v || 0]));
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    const INST = cfg.instruments.filter(i => i.name).map((i, k) => ({
      ...i, id: 'i' + k, low: +i.low || 0, high: Math.max(+i.high || 0, +i.low || 0),
      color: (i.color && i.color !== 'rgba(0,0,0,0)') ? i.color : (COLORS[i.art] || '#b48cff'), core: acoustic && i.role === 'core',
    }));
    const byId = Object.fromEntries(INST.map(i => [i.id, i]));
    const state = { on: new Set(), order: [], licence: acoustic ? 'standard' : 'exclusive', extras: new Set(), date: '' };
    const stage = $('[data-stage]'), bg = $('[data-bg]');

    // ---------- Stage layout: extras at the back, front row either side of the singer ----------
    const spread = (n, a, b) => n === 1 ? [(a + b) / 2] : Array.from({ length: n }, (_, k) => a + (b - a) * k / (n - 1));
    const backRow = INST.filter(i => i.row !== 'front'), frontRow = INST.filter(i => i.row === 'front');
    const bx = spread(backRow.length, 11, 89), bw = backRow.length > 1 ? Math.min(15, 78 / (backRow.length - 1) * .82) : 15;
    backRow.forEach((i, k) => Object.assign(i, { x: bx[k], y: 37, w: bw, d: .6 }));
    const left = frontRow.slice(0, Math.ceil(frontRow.length / 2)), right = frontRow.slice(left.length);
    const lx = spread(left.length, 19, 36), rx = spread(right.length, 64, 81);
    const fw = Math.min(17, ...[left.length, right.length].filter(n => n > 1).map(n => 18 / (n - 1) * .95));
    left.forEach((i, k) => Object.assign(i, { x: left.length === 1 ? 25 : lx[k], y: 67, w: fw, d: 1.4 }));
    right.forEach((i, k) => Object.assign(i, { x: right.length === 1 ? 75 : rx[k], y: 67, w: fw, d: 1.4 }));

    if (stage) INST.forEach(i => {
      const vars = `--c:${i.color};--x:${i.x};--y:${i.y};--d:${i.d}`;
      stage.insertAdjacentHTML('beforeend',
        `<span class="bb-beam" data-beam="${i.id}" style="${vars};--w:${i.w * 1.4}cqw"></span>
         <span class="bb-lamp" data-lamp="${i.id}" style="${vars}"></span>
         <button class="bb-inst bb-inst--${i.row === 'front' ? 'front' : 'back'}" type="button" data-inst="${i.id}" aria-pressed="false" aria-label="${esc(i.name)}" style="${vars};--w:${i.w}cqw">
           <span class="bb-inst__floor"></span><span class="bb-inst__art"><span class="bb-inst__pulse">${svg(i.art)}</span></span>
           <span class="bb-inst__ring"></span><span class="bb-inst__label">${esc(i.name)}</span>
         </button>`);
    });
    if (stage) stage.insertAdjacentHTML('beforeend',
      `<span class="bb-beam on" style="--c:#ffffff;--x:50;--y:68;--d:1.2;--w:15cqw"></span><span class="bb-lamp on" style="--c:#ffffff;--x:50;--d:1.2"></span>
       <div class="bb-inst bb-inst--front bb-inst--you on" style="--c:#ffffff;--x:50;--y:68;--d:1.2;--w:10cqw" aria-hidden="true">
         <span class="bb-inst__floor"></span><span class="bb-inst__art"><span class="bb-inst__pulse">${svg('you')}</span></span><span class="bb-inst__label">You</span></div>`);

    // ---------- Cards ----------
    const priceLabel = i => acoustic ? (i.core ? 'Included' : `+${money(P.extra)}`) : i.high > i.low ? `${money(i.low)}–${money(i.high)}` : money(i.low);
    const card = i => `<button class="bb-tog" type="button" data-tog="${i.id}" aria-pressed="false" style="--c:${i.color}">
        <span class="bb-tog__check"><svg viewBox="0 0 12 12"><path d="M2.5 6.2l2.4 2.4 4.6-5"/></svg></span>
        <span class="bb-tog__icon">${svg(i.art)}</span><span class="bb-tog__name">${esc(i.name)}</span>
        <span class="bb-tog__price" data-tog-price="${i.id}">${priceLabel(i)}</span></button>`;
    if (acoustic) {
      $('[data-core-grid]').innerHTML = INST.filter(i => i.core).map(card).join('');
      $('[data-extra-grid]').innerHTML = INST.filter(i => !i.core).map(card).join('');
      $('[data-extra-hint]').textContent = P.bulkPrice < P.extra ? `${money(P.extra)} each, or ${money(P.bulkPrice)} each when you add ${P.bulkFrom} or more` : `${money(P.extra)} each`;
      $('[data-core-hint]').textContent = `Guitar, keys or both: ${money(P.core)}`;
    } else if (band) {
      $('[data-extra-grid]').innerHTML = INST.map(card).join('');
    }
    // Acoustic: non-exclusive by default. Full band productions are always exclusive.
    const LICENCES = (acoustic
      ? [{ id: 'standard', name: 'Non-exclusive', note: 'Becomes available in our catalogue after purchase.', price: 0 },
         { id: 'exclusive', name: 'Exclusive', note: 'Yours only. Never added to our catalogue.', price: P.exclusive }]
      : [{ id: 'exclusive', name: 'Exclusive', note: 'Yours only. Never added to our catalogue.', price: 0 }])
      .concat([{ id: 'artist', name: 'Custom artist', note: 'Streaming licence, never in our catalogue, stems included.', price: P.artist }]);
    if (!ai) $('[data-licences]').style.setProperty('--lics', LICENCES.length);
    if (!ai) $('[data-licences]').innerHTML = LICENCES.map(l => `<button class="bb-lic" type="button" role="radio" aria-checked="false" data-lic="${l.id}">
        <span class="bb-lic__dot"></span><span class="bb-lic__name">${l.name}</span><span class="bb-lic__price">${l.price ? '+' + money(l.price) : 'Included'}</span>
        <span class="bb-lic__note">${l.note}</span></button>`).join('');
    const EXTRAS = [
      ...(band ? [{ id: 'live', name: 'Live brass or strings', note: 'Real horn or string players instead of synth', price: P.liveSection }] : []),
      ...(ai ? [] : [{ id: 'stems', name: 'Stems', note: 'A separate WAV file for every instrument', price: P.stems }]),
      { id: 'fast', name: 'Fast track', note: `Ready within ${P.fastTrackDays} days`, price: P.fastTrack },
      { id: 'long', name: `Track over ${P.longTrackMinutes} minutes`, note: 'For longer songs', price: P.longTrack },
    ].filter(e => e.price > 0);
    $('[data-extras]').innerHTML = EXTRAS.map(e => `<button class="bb-switch-row" type="button" role="switch" aria-checked="false" data-extra="${e.id}">
        <span class="bb-switch"></span><span>${e.name}<small>${e.note}</span><b>+${money(e.price)}</b></button>`).join('');
    const dateInput = $('[data-date]');
    const tomorrow = new Date(); tomorrow.setDate(tomorrow.getDate() + 1);
    dateInput.min = tomorrow.toISOString().slice(0, 10);

    // ---------- Pricing ----------
    const daysUntil = d => { if (!d) return Infinity; const t = new Date(); t.setHours(0, 0, 0, 0); return Math.round((new Date(d + 'T00:00') - t) / 864e5); };
    const soon = () => daysUntil(state.date) <= P.fastTrackDays;
    function quote() {
      const on = INST.filter(i => state.on.has(i.id)), lines = [];
      if (acoustic) {
        const core = on.filter(i => i.core);
        lines.push({ key: 'core', name: `Custom backing track: ${core.map(i => i.name).join(' & ')}`, low: P.core, color: '#232323' });
        const extras = on.filter(i => !i.core), bulk = extras.length >= P.bulkFrom;
        extras.forEach(i => lines.push({ key: i.id, name: i.name, low: bulk ? P.bulkPrice : P.extra, was: bulk && P.bulkPrice < P.extra ? P.extra : 0, color: i.color }));
      } else if (ai) {
        lines.push({ key: 'core', name: 'Custom AI backing track', low: P.ai, color: '#232323' });
      } else {
        lines.push({ key: 'base', name: 'Arrangement and admin fee', low: cfg.base.low, high: cfg.base.high, color: '#232323' });
        on.forEach(i => lines.push({ key: i.id, name: i.name, low: i.low, high: i.high, color: i.color }));
      }
      if (state.licence === 'exclusive') lines.push({ key: 'lic', name: 'Exclusive licence', low: acoustic ? P.exclusive : 0, color: '#6d28d9' });
      if (state.licence === 'artist') lines.push({ key: 'lic', name: 'Custom artist licence (stems included)', low: P.artist, color: '#6d28d9' });
      if (state.extras.has('live')) lines.push({ key: 'live', name: 'Live brass or strings', low: P.liveSection, color: '#ffc23d' });
      if (state.extras.has('stems') && state.licence !== 'artist') lines.push({ key: 'stems', name: 'Stems (WAV files)', low: P.stems, color: '#6d28d9' });
      if (state.extras.has('fast')) lines.push({ key: 'fast', name: `Fast track (within ${P.fastTrackDays} days)`, low: P.fastTrack, color: '#ed894b' });
      if (state.extras.has('long')) lines.push({ key: 'long', name: `Track over ${P.longTrackMinutes} minutes`, low: P.longTrack, color: '#ed894b' });
      lines.forEach(l => { if (l.high === undefined) l.high = l.low; });
      return { lines, low: lines.reduce((s, l) => s + l.low, 0), high: lines.reduce((s, l) => s + l.high, 0) };
    }
    const priceText = (lo, hi) => !band || Math.abs(hi - lo) < .005 ? money(lo) : `${money(lo)}–${money(hi)}`;

    // ---------- State → screen ----------
    let shownLines = new Set(), shown = { low: 0, high: 0 }, tweenRaf;
    function render() {
      const n = state.on.size, q = quote();
      INST.forEach(i => {
        const on = state.on.has(i.id);
        $(`[data-inst="${i.id}"]`).classList.toggle('on', on);
        $(`[data-inst="${i.id}"]`).setAttribute('aria-pressed', on);
        $(`[data-beam="${i.id}"]`).classList.toggle('on', on);
        $(`[data-lamp="${i.id}"]`).classList.toggle('on', on);
        $(`[data-tog="${i.id}"]`).setAttribute('aria-pressed', on);
      });
      if (acoustic) {
        const bulk = INST.filter(i => !i.core && state.on.has(i.id)).length >= P.bulkFrom;
        INST.filter(i => !i.core).forEach(i => { $(`[data-tog-price="${i.id}"]`).textContent = `+${money(bulk ? P.bulkPrice : P.extra)}`; });
      }
      $$('[data-lic]').forEach(b => b.setAttribute('aria-checked', b.dataset.lic === state.licence));
      $$('[data-extra]').forEach(b => {
        const e = EXTRAS.find(x => x.id === b.dataset.extra), included = e.id === 'stems' && state.licence === 'artist';
        b.setAttribute('aria-checked', included || state.extras.has(e.id));
        b.classList.toggle('is-included', included);
        b.querySelector('b').textContent = included ? 'Included' : '+' + money(e.price);
      });
      $('[data-fast-note]').hidden = !(soon() && !state.extras.has('fast'));

      // Receipt lines; new ones slide in
      $('[data-lines]').innerHTML = q.lines.map(l => `<div class="bb-line${shownLines.has(l.key) ? '' : ' is-new'}" style="--c:${l.color}">
          <span class="bb-line__dot"></span><span class="bb-line__name">${esc(l.name)}</span>
          <span class="bb-line__price">${l.was ? `<s>${money(l.was)}</s> ` : ''}${l.high ? priceText(l.low, l.high) : 'Included'}</span></div>`).join('');
      shownLines = new Set(q.lines.map(l => l.key));
      if (!stage) return tweenTotal(q.low, q.high);
      $('[data-chip]').textContent = `${n + 1} on stage · ${priceText(q.low, q.high)}`;
      stage.classList.toggle('is-empty', n === 0);

      const recent = state.order.filter(id => state.on.has(id)).slice(-3).reverse().map(id => byId[id].color);
      const a = .38 + Math.min(n, 8) * .05;
      bg.style.setProperty('--c1', recent[0] ? rgba(recent[0], a) : 'rgba(124,58,237,.32)');
      bg.style.setProperty('--c2', recent[1] ? rgba(recent[1], a * .8) : 'rgba(79,141,255,.12)');
      bg.style.setProperty('--c3', recent[2] ? rgba(recent[2], a * .8) : 'rgba(255,111,145,.10)');
      tweenTotal(q.low, q.high);
    }
    function paintTotal(lo, hi) {
      const t = priceText(lo, hi);
      $$('[data-total]').forEach(el => { el.textContent = t; });
      $$('[data-send-label]').forEach(el => { el.textContent = band ? `Send request · est. ${t}` : `Send request · ${t}`; });
    }
    function tweenTotal(lo, hi) {
      const from = { ...shown }, t0 = performance.now(), dur = reduce ? 1 : 650;
      cancelAnimationFrame(tweenRaf);
      const frame = now => {
        const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        shown = { low: from.low + (lo - from.low) * e, high: from.high + (hi - from.high) * e };
        paintTotal(k < 1 ? Math.round(shown.low) : lo, k < 1 ? Math.round(shown.high) : hi);
        if (k < 1) tweenRaf = requestAnimationFrame(frame);
      };
      tweenRaf = requestAnimationFrame(frame);
    }
    function burst(id) {
      if (reduce) return;
      $(`[data-inst="${id}"] .bb-inst__ring`).animate([{ transform: 'scale(.55)', opacity: .9 }, { transform: 'scale(1.75)', opacity: 0 }], { duration: 1000, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    let toastTimer;
    function toast(msg) { const t = $('[data-toast]'); t.textContent = msg; t.classList.add('show'); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('show'), 3600); }

    function toggle(id, on = !state.on.has(id), sound = true) {
      if (on === state.on.has(id)) return;
      const inst = byId[id];
      if (!on && inst.core && INST.filter(i => i.core && state.on.has(i.id)).length === 1) {
        if (!reduce) $(`[data-tog="${id}"]`).animate([{ transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'none' }], { duration: 240 });
        toast('Every track has guitar, keys or both. Pick the other one first.');
        return;
      }
      if (on) { state.on.add(id); state.order = state.order.filter(x => x !== id).concat(id); burst(id); }
      else state.on.delete(id);
      audio.set(id, on);
      if (on && sound) audio.preview(id);
      render();
    }

    // ---------- Sound: real stems if set on the blocks, otherwise placeholder sounds ----------
    const audio = createAudio(INST, state, cfg.stemLoop || {});

    // ---------- Visualiser, levels and gentle drift ----------
    const canvas = $('[data-viz]'), g2d = canvas && canvas.getContext('2d'), buf = new Uint8Array(128);
    let hovering = false, frame = 0;
    if (stage) (function draw(now) {
      requestAnimationFrame(draw);
      if (!reduce && !hovering && ++frame % 4 === 0) {
        stage.style.setProperty('--px', (Math.sin(now / 3200) * .45).toFixed(3));
        stage.style.setProperty('--py', (Math.cos(now / 4100) * .3).toFixed(3));
      }
      const an = audio.analyser; if (!an) return;
      if (!reduce) INST.forEach(i => { const el = $(`[data-inst="${i.id}"]`); el.style.setProperty('--lvl', state.on.has(i.id) ? audio.level(i.id).toFixed(3) : 0); });
      const dpr = devicePixelRatio || 1, w = canvas.clientWidth, h = canvas.clientHeight;
      if (canvas.width !== Math.round(w * dpr)) { canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); }
      g2d.setTransform(dpr, 0, 0, dpr, 0, 0); g2d.clearRect(0, 0, w, h);
      an.getByteFrequencyData(buf);
      const n = 36, bw2 = w / (n * 2);
      for (let i = 0; i < n; i++) {
        const v = buf[Math.floor(i * 1.6) + 1] / 255, bh = Math.max(1.5, v * v * h * .95);
        g2d.fillStyle = `rgba(255,255,255,${(.06 + v * .32).toFixed(3)})`;
        g2d.fillRect(w / 2 + i * bw2 + bw2 * .22, h - bh, bw2 * .56, bh);
        g2d.fillRect(w / 2 - (i + 1) * bw2 + bw2 * .22, h - bh, bw2 * .56, bh);
      }
    })(0);

    // ---------- Events ----------
    if (stage) stage.addEventListener('pointermove', e => {
      if (reduce || e.pointerType !== 'mouse') return;
      hovering = true;
      const r = stage.getBoundingClientRect();
      stage.style.setProperty('--px', ((e.clientX - r.left) / r.width * 2 - 1).toFixed(3));
      stage.style.setProperty('--py', ((e.clientY - r.top) / r.height * 2 - 1).toFixed(3));
    });
    if (stage) stage.addEventListener('pointerleave', () => { hovering = false; });
    $$('[data-inst]').forEach(b => b.addEventListener('click', () => toggle(b.dataset.inst)));
    $$('[data-tog]').forEach(b => b.addEventListener('click', () => toggle(b.dataset.tog)));
    $$('[data-lic]').forEach(b => b.addEventListener('click', () => { state.licence = b.dataset.lic; render(); }));
    $$('[data-extra]').forEach(b => b.addEventListener('click', () => {
      const id = b.dataset.extra;
      if (id === 'stems' && state.licence === 'artist') return;            // already included
      state.extras.has(id) ? state.extras.delete(id) : state.extras.add(id);
      render();
    }));
    dateInput.addEventListener('change', () => { state.date = dateInput.value; render(); });
    const play = $('[data-play]');
    if (play) play.addEventListener('click', async () => {
      if (audio.playing) audio.stop();
      else {
        play.classList.add('is-loading'); $('[data-play-label]').textContent = 'Loading…';
        await audio.start(); play.classList.remove('is-loading');
        if (audio.failed) toast("Sorry, the band sound wouldn't load on this device. Try refreshing the page, or another browser.");
      }
      play.classList.toggle('is-playing', audio.playing);
      $('[data-play-label]').textContent = audio.playing ? 'Pause' : 'Hear your band';
      play.setAttribute('aria-label', audio.playing ? 'Pause' : 'Play your band');
    });

    // ---------- Request ----------
    const form = $('[data-form]');
    // Say what's missing next to the Send button and jump to the field. The browser's own
    // pop-up is easy to miss on a phone, where the field can be far above the button.
    function invalidField() {
      const bad = [...form.elements].find(el => el.willValidate && !el.checkValidity());
      if (!bad) return false;
      const label = ($(`label[for="${bad.id}"]`)?.textContent || 'this field').trim().replace(/\?$/, '');
      const v = bad.validity, from = bad.min && new Date(bad.min + 'T00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
      const msg = v.valueMissing ? `Please fill in "${label}".`
        : v.rangeUnderflow ? `Please pick a date from ${from} onwards.`
        : v.typeMismatch ? `Please check "${label}": it doesn't look quite right.`
        : bad.validationMessage;
      $$('.bb-field.is-invalid').forEach(f => f.classList.remove('is-invalid'));
      bad.closest('.bb-field')?.classList.add('is-invalid');
      bad.closest('.bb-field')?.setAttribute('data-msg', msg);
      $('[data-error]').textContent = msg;
      $('[data-error]').hidden = false;
      bad.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      bad.focus({ preventScroll: true });
      return true;
    }
    form.addEventListener('input', e => {
      const field = e.target.closest('.bb-field');
      if (field?.classList.contains('is-invalid') && e.target.checkValidity()) { field.classList.remove('is-invalid'); $('[data-error]').hidden = true; }
    });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (invalidField()) return;
      const fd = new FormData(form), q = quote();
      const payload = {
        mode: cfg.mode,
        instruments: INST.filter(i => state.on.has(i.id)).map(i => ({ name: i.name, role: i.core ? 'core' : 'extra', low: i.low, high: i.high })),
        licence: state.licence, stems: state.extras.has('stems') || state.licence === 'artist', fast_track: state.extras.has('fast'), long_track: state.extras.has('long'), live_section: state.extras.has('live'),
        name: fd.get('name'), email: fd.get('email'), song: fd.get('song'), artist: fd.get('artist'),
        reference: fd.get('reference'), date: fd.get('date'), details: fd.get('details'),
        estimate: { low: q.low, high: q.high }, base: cfg.base, page: location.pathname,
      };
      const sendBtns = $$('[data-send]');
      if (!cfg.portal) { done(true, payload.name); return; }
      // Show the click has registered: spinner and "Sending…" until the portal answers
      sendBtns.forEach(b => { b.disabled = true; b.classList.add('is-sending'); b.setAttribute('aria-busy', 'true'); });
      $$('[data-send-label]').forEach(el => { el.textContent = 'Sending your request…'; });
      $('[data-error]').hidden = true;
      const timeout = new AbortController(), timer = setTimeout(() => timeout.abort(), 30000);
      try {
        const r = await fetch(cfg.portal.replace(/\/+$/, '') + '/api/builder/request', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: timeout.signal });
        const j = await r.json().catch(() => ({}));
        if (!r.ok || !j.ok) throw new Error(j.error || 'Something went wrong sending your request.');
        done(false, payload.name);
      } catch (err) {
        const msg = err.name === 'AbortError' ? 'This is taking longer than it should.' : err.message;
        $('[data-error]').textContent = `${msg} Please try again, or email us.`;
        $('[data-error]').hidden = false;
      } finally {
        clearTimeout(timer);
        sendBtns.forEach(b => { b.disabled = false; b.classList.remove('is-sending'); b.removeAttribute('aria-busy'); });
        paintTotal(q.low, q.high);
      }
    });
    function done(preview, name) {
      $('[data-form-card]').innerHTML = `<div class="bb-done"><span class="bb-done__tick">✓</span>
        <h3>${preview ? 'Preview: request not sent' : `Thanks ${esc(String(name).split(' ')[0])}, we've got it!`}</h3>
        <p>${preview ? 'This page is a preview, so nothing was sent. Once it\'s live, your request arrives with Sheldon as a draft order, and he emails you a secure link to pay.'
          : 'We\'ll check your request and email you a secure link to pay. Nothing to pay until then.'}</p></div>`;
      $$('[data-send]').forEach(b => { b.hidden = true; });
      $('[data-form-card]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    // ---------- Start: the default line-up walks on ----------
    render();
    const start = INST.filter(i => i.on);
    start.forEach((i, k) => setTimeout(() => toggle(i.id, true, false), reduce ? 0 : 450 + k * 160));
  }

  // ==========================================================================
  // Audio. Stems mode: every stem loops in sync and the toggles mute/unmute.
  // Placeholder mode: a little band synthesised in the browser.
  // ==========================================================================
  function createAudio(INST, state, loop) {
    let ctx, master, analyser, reverb, noise, timer = null, nextTime = 0, step = 0, playing = false, session = null, sources = [], loading = null, failed = false;
    const gains = {}, meters = {}, plucks = {}, buffers = {}, lvlBuf = new Float32Array(256);
    const useStems = INST.some(i => i.stem);
    const BPM = 94, S = 60 / BPM / 4;
    const PROG = [{ r: 43, c: [55, 59, 62] }, { r: 38, c: [54, 57, 62] }, { r: 40, c: [55, 59, 64] }, { r: 36, c: [55, 60, 64] }];
    const VOL = { drums: .9, percussion: .7, bass: .8, double_bass: .85, keys: .55, guitar: .6, electric_guitar: .5, banjo: .45, strings: .5, brass: .42, synths: .32 };
    const REV = { drums: .1, percussion: .15, bass: .03, double_bass: .08, keys: .25, guitar: .22, electric_guitar: .2, banjo: .2, strings: .45, brass: .2, synths: .3 };
    const vol = i => useStems ? 1 : (VOL[i.art] || .5);
    const mtof = m => 440 * Math.pow(2, (m - 69) / 12);

    function init() {
      if (ctx) return;
      // iPhones mute web audio when the side switch is on silent unless the page says it's media playback (iOS 16.4+)
      try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
      ctx = new (window.AudioContext || window.webkitAudioContext)();
      const comp = ctx.createDynamicsCompressor(); comp.threshold.value = -16; comp.ratio.value = 3;
      master = ctx.createGain(); master.gain.value = .8;
      analyser = ctx.createAnalyser(); analyser.fftSize = 256; analyser.smoothingTimeConstant = .82;
      master.connect(comp); comp.connect(analyser); analyser.connect(ctx.destination);
      reverb = ctx.createConvolver(); reverb.buffer = impulse(2.4); reverb.connect(master);
      noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      const nd = noise.getChannelData(0); for (let i = 0; i < nd.length; i++) nd[i] = Math.random() * 2 - 1;
      INST.forEach(i => {
        const g = ctx.createGain(), m = ctx.createAnalyser();
        g.gain.value = state.on.has(i.id) ? vol(i) : 0; m.fftSize = 256;
        g.connect(master); g.connect(m); gains[i.id] = g; meters[i.id] = m;
        if (!useStems) { const send = ctx.createGain(); send.gain.value = REV[i.art] || .2; g.connect(send); send.connect(reverb); }
      });
      if (!useStems) INST.filter(i => i.art === 'synths').forEach(i => {         // synth echo
        const dl = ctx.createDelay(1), fb = ctx.createGain(), wet = ctx.createGain();
        dl.delayTime.value = S * 3; fb.gain.value = .38; wet.gain.value = .4;
        gains[i.id].connect(dl); dl.connect(fb); fb.connect(dl); dl.connect(wet); wet.connect(master);
      });
    }
    function impulse(sec) {
      const r = ctx.sampleRate, len = Math.floor(r * sec), b = ctx.createBuffer(2, len, r);
      for (let c = 0; c < 2; c++) { const d = b.getChannelData(c); for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3.2); }
      return b;
    }
    function pluck(f) {
      const r = ctx.sampleRate, N = Math.max(2, Math.round(r / f)), len = Math.floor(r * 1.8);
      const b = ctx.createBuffer(1, len, r), d = b.getChannelData(0), ring = new Float32Array(N);
      let prev = 0; for (let i = 0; i < N; i++) { const x = Math.random() * 2 - 1; ring[i] = (x + prev) * .5; prev = x; }
      for (let i = 0, p = 0; i < len; i++) { const a = ring[p]; d[i] = a; ring[p] = .4985 * (a + ring[(p + 1) % N]); p = (p + 1) % N; }
      return b;
    }
    const osc = (type, freq, t, end) => { const o = ctx.createOscillator(); o.type = type; o.frequency.value = freq; o.start(t); o.stop(end); return o; };
    const amp = () => ctx.createGain();
    const filt = (type, f, q = .7) => { const x = ctx.createBiquadFilter(); x.type = type; x.frequency.value = f; x.Q.value = q; return x; };
    const chain = (...n) => { for (let i = 0; i < n.length - 1; i++) n[i].connect(n[i + 1]); };
    const env = (g, t, peak, a, decayTo, d) => { g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + a); g.gain.exponentialRampToValueAtTime(decayTo, t + a + d); };

    function kick(t, out) { const o = osc('sine', 150, t, t + .5), g = amp(); o.frequency.setValueAtTime(150, t); o.frequency.exponentialRampToValueAtTime(42, t + .12); g.gain.setValueAtTime(1, t); g.gain.exponentialRampToValueAtTime(.001, t + .45); chain(o, g, out); }
    function snare(t, out) {
      const n = ctx.createBufferSource(), g = amp(); n.buffer = noise; g.gain.setValueAtTime(.7, t); g.gain.exponentialRampToValueAtTime(.001, t + .2); chain(n, filt('bandpass', 1800), g, out); n.start(t); n.stop(t + .22);
      const o = osc('triangle', 190, t, t + .12), og = amp(); og.gain.setValueAtTime(.5, t); og.gain.exponentialRampToValueAtTime(.001, t + .1); chain(o, og, out);
    }
    function hat(t, out, v = .22, len = .05, f = 7500) { const n = ctx.createBufferSource(), g = amp(); n.buffer = noise; g.gain.setValueAtTime(v, t); g.gain.exponentialRampToValueAtTime(.001, t + len); chain(n, filt('highpass', f), g, out); n.start(t, Math.random() * .5); n.stop(t + len + .02); }
    function conga(t, out, f = 210) { const o = osc('sine', f, t, t + .3), g = amp(); o.frequency.setValueAtTime(f * 1.3, t); o.frequency.exponentialRampToValueAtTime(f, t + .03); g.gain.setValueAtTime(.6, t); g.gain.exponentialRampToValueAtTime(.001, t + .25); chain(o, g, out); }
    function bassNote(t, m, dur, out, cut = 900, saw = .35) {
      const o = osc('sawtooth', mtof(m), t, t + dur + .3), sub = osc('sine', mtof(m), t, t + dur + .3), og = amp(), f = filt('lowpass', cut, 2), g = amp();
      og.gain.value = saw; f.frequency.setValueAtTime(cut, t); f.frequency.exponentialRampToValueAtTime(cut * .42, t + dur);
      g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.9, t + .01); g.gain.setTargetAtTime(.5, t + .02, .15); g.gain.setTargetAtTime(.0001, t + dur - .02, .04);
      chain(o, og, f); chain(sub, f, g, out);
    }
    function epNote(t, m, dur, out, v = .25) {
      [[1, v], [2, v * .25], [3.98, v * .06]].forEach(([mul, a]) => {
        const o = osc('sine', mtof(m) * mul, t, t + dur + .7), g = amp();
        g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(a, t + .006); g.gain.exponentialRampToValueAtTime(a * .35, t + .25); g.gain.setTargetAtTime(.0001, t + dur, .12);
        chain(o, g, out);
      });
    }
    function pluckNote(t, m, out, v = .6, cut = 3800) { const s = ctx.createBufferSource(), g = amp(); s.buffer = plucks[m] || (plucks[m] = pluck(mtof(m))); g.gain.value = v; chain(s, filt('lowpass', cut), g, out); s.start(t); }
    function pad(t, notes, dur, out) {
      notes.forEach(m => [-7, 7].forEach(c => {
        const o = osc('sawtooth', mtof(m), t, t + dur + .6), g = amp(); o.detune.value = c;
        g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.09, t + .45); g.gain.setValueAtTime(.09, t + dur - .1); g.gain.exponentialRampToValueAtTime(.0001, t + dur + .5);
        chain(o, filt('lowpass', 1500, .3), g, out);
      }));
    }
    function stab(t, notes, dur, out) {
      notes.forEach(m => [-5, 6].forEach(c => {
        const o = osc('sawtooth', mtof(m), t, t + dur + .3), f = filt('lowpass', 400, 1), g = amp(); o.detune.value = c;
        f.frequency.setValueAtTime(400, t); f.frequency.exponentialRampToValueAtTime(2600, t + .05); f.frequency.exponentialRampToValueAtTime(900, t + dur);
        g.gain.setValueAtTime(.0001, t); g.gain.exponentialRampToValueAtTime(.12, t + .03); g.gain.setTargetAtTime(.0001, t + dur, .05);
        chain(o, f, g, out);
      }));
    }
    function blip(t, m, out) { const o = osc('square', mtof(m), t, t + .2), f = filt('lowpass', 3200), g = amp(); f.frequency.setValueAtTime(3200, t); f.frequency.exponentialRampToValueAtTime(700, t + .14); env(g, t, .16, .005, .0001, .155); chain(o, f, g, out); }

    // One bar is 16 steps; each part plays its notes for step s of the chord p
    const PART = {
      drums(s, p, t, bar, o) {
        if (s === 0 || s === 8 || (s === 10 && bar % 2)) kick(t, o);
        if (s === 4 || s === 12 || (bar === 3 && s === 15)) snare(t, o);
        if (s % 2 === 0) hat(t, o, s % 4 === 0 ? .22 : .13);
        if (s === 14 && bar % 2) hat(t, o, .16, .22);
      },
      percussion(s, p, t, bar, o) {
        hat(t, o, s % 4 === 2 ? .14 : .07, .04, 5000);
        if (s === 0 || s === 6 || s === 10) conga(t, o, s === 6 ? 260 : 200);
        if (s === 12 && bar % 2) conga(t, o, 300);
      },
      bass(s, p, t, bar, o) { const n = { 0: [0, 5], 6: [0, 2], 8: [7, 3], 11: [0, 1], 12: [0, 2], 14: [12, 2] }[s]; if (n) bassNote(t, p.r + n[0], n[1] * S, o); },
      double_bass(s, p, t, bar, o) { const n = { 0: [0, 3], 4: [7, 3], 8: [12, 3], 12: [7, 3] }[s]; if (n) bassNote(t, p.r + n[0], n[1] * S, o, 520, .12); },
      keys(s, p, t, bar, o) { const len = { 0: 6, 6: 4, 10: 6 }[s]; if (len) { p.c.forEach(m => epNote(t, m, len * S, o)); epNote(t, p.r + 12, len * S, o, .15); } },
      guitar(s, p, t, bar, o) { if (s % 2) return; const tones = [p.r + 12, p.c[0] + 12, p.c[1] + 12, p.c[2] + 12]; pluckNote(t, tones[[0, 2, 1, 3, 2, 1, 3, 2][s / 2]], o, s === 0 ? .7 : .5); },
      electric_guitar(s, p, t, bar, o) { if (s === 0 || s === 6 || s === 10) [p.c[0], p.c[1], p.c[2], p.c[0] + 12].forEach((m, k) => pluckNote(t + k * .014, m, o, .35, 2600)); },
      banjo(s, p, t, bar, o) { const roll = [p.c[0] + 12, p.c[1] + 12, p.c[2] + 12, p.c[0] + 24]; pluckNote(t, roll[s % 4], o, s % 4 === 0 ? .45 : .3, 6000); },
      strings(s, p, t, bar, o) { if (!s) pad(t, [p.r + 12, p.c[0], p.c[1] + 12, p.c[2] + 12], 16 * S, o); },
      brass(s, p, t, bar, o) { if (s === 0 || s === 3) stab(t, [p.r + 12, ...p.c], (s ? 1 : 1.5) * S, o); else if (bar === 3 && s === 14) stab(t, [PROG[0].r + 12, ...PROG[0].c], S, o); },
      synths(s, p, t, bar, o) { const arp = [p.c[0] + 12, p.c[1] + 12, p.c[2] + 12, p.c[1] + 24, p.c[2] + 12, p.c[1] + 12, p.c[0] + 24, p.c[2] + 12]; blip(t, arp[s % 8], o); },
    };
    const partFor = i => PART[i.art] || PART.keys;

    // Throwaway gains per play, so stopping cuts every note already queued
    function newSession(ids) { const s = {}; ids.forEach(id => { const g = amp(); g.connect(gains[id]); s[id] = g; }); return s; }
    function endSession(s, at = ctx.currentTime) { Object.values(s).forEach(g => { g.gain.setTargetAtTime(0, at, .06); setTimeout(() => g.disconnect(), (at - ctx.currentTime) * 1000 + 600); }); }
    function schedule(st, t) { const bar = st >> 4, s = st & 15; INST.forEach(i => partFor(i)(s, PROG[bar], t, bar, session[i.id])); }
    function tick() { while (nextTime < ctx.currentTime + .12) { schedule(step, nextTime); nextTime += S; step = (step + 1) % 64; } }
    function loadStems() {
      loading = loading || Promise.all(INST.filter(i => i.stem).map(i => fetch(i.stem).then(r => r.arrayBuffer()).then(b => ctx.decodeAudioData(b)).then(d => { buffers[i.id] = d; }).catch(() => {})));
      return loading;
    }

    return {
      get analyser() { return analyser; },
      get playing() { return playing; },
      get failed() { return failed; },
      level(id) {
        const m = meters[id]; if (!m) return 0;
        m.getFloatTimeDomainData(lvlBuf); let sum = 0; for (let i = 0; i < lvlBuf.length; i++) sum += lvlBuf[i] * lvlBuf[i];
        return Math.min(1, Math.sqrt(sum / lvlBuf.length) * 4);
      },
      async start() {
        init(); await ctx.resume(); if (playing) return;
        if (useStems) {
          await loadStems();
          const t = ctx.currentTime + .1, loaded = INST.filter(i => buffers[i.id]);
          failed = !loaded.length; if (failed) return;           // stems wouldn't load or decode (e.g. out of memory)
          // Optional loop points (section settings), so the loop never includes the gap MP3s carry at each end
          const shortest = Math.min(...loaded.map(i => buffers[i.id].duration));
          const from = +loop.start || 0, to = +loop.end || 0, region = to > from && to <= shortest;
          sources = loaded.map(i => {
            const s = ctx.createBufferSource(); s.buffer = buffers[i.id]; s.loop = true;
            s.loopStart = region ? from : 0; s.loopEnd = region ? to : shortest;
            s.connect(gains[i.id]); s.start(t, s.loopStart); return s;
          });
          playing = true; return;
        }
        playing = true; session = newSession(INST.map(i => i.id)); step = 0; nextTime = ctx.currentTime + .06;
        tick(); timer = setInterval(tick, 25);
      },
      stop() {
        if (!playing) return; playing = false;
        if (useStems) { sources.forEach(s => { try { s.stop(); } catch (e) {} }); sources = []; return; }
        clearInterval(timer); endSession(session); session = null;
      },
      set(id, on) { const i = INST.find(x => x.id === id); if (ctx) gains[id].gain.setTargetAtTime(on ? vol(i) : 0, ctx.currentTime, on ? .08 : .18); },
      async preview(id) {                                  // a moment of that instrument when the band isn't playing
        if (playing) return;
        init(); await ctx.resume();
        const t0 = ctx.currentTime + .04, i = INST.find(x => x.id === id);
        if (useStems) {
          await loadStems(); if (!buffers[id] || playing) return;
          const s = ctx.createBufferSource(), g = amp(); s.buffer = buffers[id]; chain(s, g, gains[id]);
          g.gain.setValueAtTime(1, t0); g.gain.setTargetAtTime(0, t0 + 2.6, .25); s.start(t0); s.stop(t0 + 4);
          return;
        }
        const s = newSession([id]);
        for (let st = 0; st < 8; st++) partFor(i)(st, PROG[0], t0 + st * S, 0, s[id]);
        endSession(s, t0 + 8 * S);
      },
    };
  }
})();
